<template>
  <div class="background-01">
    <v-layout row wrap text-xs-right>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Qué son los ingresos fijos?" titleLevel="h1">
              <template slot="partOne">¿Qué son los <br></template>
              <!-- <template slot="partTwo"></template> -->
              <template slot="partThree"> ingresos fijos?</template>
            </ui-title-one>
      </v-flex>
      <v-flex xs12 sm2 text-xs-right class="hidden-xs-only ">
        <image-app class="animated fadeInRight" :imaSize="250" imaSrc="design/banco1-1-3-2" imaAlt=""></image-app>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Qué son los ingresos fijos?'" videoEmbed="ADMINISTRACIONDINERO20QueSonIngresosFIjos (51).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="animated fadeIn dura_2">
        <image-app class="animated fadeInLeft" :imaSize="500" imaSrc="contenido/diapositiva_21" imaAlt="Mano escogiendo una bolsa de monedas"></image-app>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Son aquellos que una persona recibe de manera <strong>estable</strong> y <strong>repetitiva</strong> en cada periodo de tiempo
              y por el mismo valor. Por ejemplo, el <strong>salario</strong> o la <strong>renta</strong> de un apartamento que se encuentre alquilado.
        </p>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-20.vue?d6415312